export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_displayImage') || '图片',
    field: 'displayImage',
    width: 80,
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_displayName') || '产品名称',
    field: 'displayName',
    minWidth: 250,
    align: 'left',
    slots: { default: 'displayName' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displaySpecColor') || '规格颜色',
    field: 'displaySpecColor',
    minWidth: 180,
    align: 'left',
    slots: { default: 'displaySpecColor' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayNo') || '产品编号',
    field: 'displayNo',
    minWidth: 180,
    align: 'left',
    slots: { default: 'displayNo' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayUnit') || '产品单位入数',
    field: 'displayUnit',
    width: 150,
    align: 'left',
    slots: { default: 'displayUnit' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_unitQty') || '采购数量',
    field: 'unitQty',
    align: 'center',
    width: 150,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_unitPrice') || '采购单价',
    field: 'unitPrice',
    align: 'center',
    width: 150,
    slots: { default: 'unitPrice' },
  },
  {
    title: that.$l('table_label_unitAmount') || '采购金额',
    field: 'unitAmount',
    align: 'center',
    width: 150,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
]
